import { gql, TypedDocumentNode } from "@apollo/client";

export const GetOrderItemHistoryDocument = gql`
  query GetOrderItemHistory($itemId: Int!) {
    orderItemHistory(itemId: $itemId)
  }
`;

export const GetSalesByCustomerDocument = gql`
  query GetSalesByCustomer($request: OrderSalesByCustomerRequest!) {
    salesByCustomer(request: $request)
  }
`;

export const GetOrderPaymentsDocuments = gql`
  query GetOrderPayments($request: OrderPaymentsReportRequest!) {
    orderPayments(request: $request)
  }
`;

export const GetSalesByVendorDocument = gql`
  query getSalesByVendor($request: OrderSalesVendorReportRequest!) {
    salesByVendor(request: $request)
  }
`;

export const GetDeliverableReportDocument = gql`
  query GetDeliverableReport(
    $request: PurchaseOrderBackOrderDeliverablesRequest!
  ) {
    purchaseOrderBackOrderDeliverablesFind(request: $request) {
      count
      data {
        id
        orderId
        contactId
        name
        sku
        description
        purchaseOrderNumber
        email
        phone
        emailSent
      }
    }
  }
`;

export const GetReceivedBackOrderCountQuery: TypedDocumentNode<{
  purchaseOrderBackOrderDeliverablesNewCount: number
}> = gql`
  query GetReceivedBackOrderCount {
    purchaseOrderBackOrderDeliverablesNewCount
  }
`;

export const SetReceivedBackOrdersSeenMutation: TypedDocumentNode<void> = gql`
  mutation SetReceivedBackOrdersSeen {
    purchaseOrderBackOrderDeliverablesSetAsSeen
  }
`;
